import { http } from '@/libs/util'
import util from '@/libs/util'
export const { 
    placing_ads_sku_list,
    placing_ads_sku_all,
    placing_ads_sku_save,
    placing_ads_sku_change_status,
    enum_config_list,
    enum_config_add,
    enum_config_update,
    enum_config_change_status,
    placing_ads_kol_mark_risk_kol
 } = util.api || {}

export function getplacingAdsSkuQueryListApi(params) {
    return http.get(placing_ads_sku_list, params)
}
export function getplacingAdsSkuQueryAllApi(params) {
    return http.get(placing_ads_sku_all, params)
}
export function getplacingAdsSkuSaveApi(params) {
    return http.post(placing_ads_sku_save, params)
}
export function postPlacingAdsSkuChangeApi(params) {
    return http.post(placing_ads_sku_change_status, params)
}
export function getEnumConfigListApi(params) {
    return http.get(enum_config_list, params)
}
export function postEnumConfigAddApi(params) {
    return http.post(enum_config_add, params)
}
export function postEnumConfigUpdateApi(params) {
    return http.post(enum_config_update, params)
}

export function postEnumConfigChangeStatusApi(params) {
    return http.post(enum_config_change_status, params)
}

export function postPlacingAdsKolMarkRiskKolApi(params) {
    return http.post(placing_ads_kol_mark_risk_kol, params)
}